module.exports = __webpack_public_path__ + "786133a5826740233ae8b8f26e1f8826.png";